import { ThemeContext } from '@/state/Theme';
import { type BannerLinkGridProps } from './BannerLinkGrid.types';

const BannerLinkGrid: React.FC<BannerLinkGridProps> = ({ items, title }) => (
  <ThemeContext.Consumer>
    {(theme) => (
      <div
        className="banner-link-grid"
        style={{
          background: theme.colorApplication.bannerLinkGridBackground,
        }}
      >
        <div className="banner-link-grid__container container">
          <div className="banner-link-grid__main">
            {title && (
              <h2
                className="banner-link-grid__heading h3"
                style={{
                  color: theme.colorApplication.bannerLinkGridColor,
                }}
              >
                {title}
              </h2>
            )}
            <ol className="banner-link-grid__list">
              {items.map((item) => (
                <li key={item.id} className="banner-link-grid__list-item">
                  <a
                    className="banner-link-grid__list-link h6"
                    href={item.link}
                    style={{
                      color: theme.colorApplication.bannerLinkGridColor,
                    }}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    )}
  </ThemeContext.Consumer>
);

export default BannerLinkGrid;
